import React from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import '../assets/bociany-style.css';

export function VideoJS({ options, onReady, className }) {
    const videoRef = React.useRef(null);
    const playerRef = React.useRef(null);
    const onReadyRef = React.useRef(onReady);
    onReadyRef.current = onReady;

    React.useEffect(() => {
        const mount = videoRef.current;
        if (!mount || playerRef.current) return;
        const el = document.createElement('video-js');
        el.classList.add('vjs-bociany');
        mount.appendChild(el);
        playerRef.current = videojs(el, options, function onPlayerReady() {
            onReadyRef.current?.(this);
        });
    }, [options]);

    React.useEffect(() => {
        const player = playerRef.current;
        return () => {
            if (player && !player.isDisposed()) {
                player.dispose();
                playerRef.current = null;
            }
        };
    }, []);

    return (
        <div data-vjs-player className={className ?? ''}>
            <div ref={videoRef} className="h-full w-full" />
        </div>
    );
}

export default VideoJS;
